import { render, staticRenderFns } from "./DirectDebit.vue?vue&type=template&id=d87fdd88"
import script from "./DirectDebit.vue?vue&type=script&lang=js"
export * from "./DirectDebit.vue?vue&type=script&lang=js"
import style0 from "./DirectDebit.vue?vue&type=style&index=0&id=d87fdd88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports